import React from "react";
import { PiLadderBold } from "react-icons/pi";
import { VscWorkspaceTrusted } from "react-icons/vsc";
import { LiaCommentDollarSolid } from "react-icons/lia";
import { FiLifeBuoy } from "react-icons/fi";
import why from "../../assets/images/yogesh lader1.png";
import svg from "../../assets/images/svg/dots-yellow.svg";

const WhyChoose = () => {
  return (
    <>
      <section className=" my-5 md:my-10 lg:my-14">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-between">
            <div className="lg:w-1/2">
              <h2 className=" text-3xl font-bold text-[#142a4e]" data-aos="fade-left">
                Why Choose Us
              </h2>
              <p className="mt-4 text-gray-600 tracking-wide leading-relaxed">
                Made from high-quality aluminium materials, our ladders are
                built to last. Whether you need a ladder for residential,
                commercial, or industrial use, Yogesh Aluminium Ladder stands
                the test of time and usage.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
                <div data-aos="fade-down">
                  <div className="space-y-2">
                    <div className="relative mr-4">
                      <PiLadderBold className="text-4xl text-black" />
                      <p className="absolute bottom-0 translate-x-2 bg-[#3b5d5033] rounded-full h-[33px] w-[33px] -z-10"></p>
                    </div>
                    <div className="bg-[#3b5d5033] text-black p-4 rounded-md">
                      <h3 className="text-lg font-semibold">Safety First</h3>
                      <p className="text-sm text-gray-600 tracking-wide leading-relaxed">
                        Our aluminium ladders prioritize safety with sturdy,
                        non-slip design. Work confidently at any height,
                        ensuring safety without compromise.
                      </p>
                    </div>
                  </div>
                </div>

                <div data-aos="fade-down">
                  <div className="space-y-2">
                    <div className="relative mr-4">
                      <VscWorkspaceTrusted className="text-4xl text-black" />
                      <p className="absolute bottom-0 translate-x-2 bg-[#3b5d5033] rounded-full h-[33px] w-[33px] -z-10"></p>
                    </div>
                    <div className=" text-black p-4 ">
                      <h3 className="text-lg font-semibold">Trusted Brand</h3>
                      <p className="text-sm text-gray-600 tracking-wide leading-relaxed">
                        Yogesh Aluminium Ladder is a trusted name for quality,
                        reliability, and customer satisfaction.
                      </p>
                    </div>
                  </div>
                </div>

                <div data-aos="fade-up">
                  <div className="space-y-2">
                    <div className="relative mr-4">
                      <FiLifeBuoy className="text-4xl text-black" />
                      <p className="absolute bottom-0 translate-x-3 bg-[#3b5d5033] rounded-full h-[33px] w-[33px] -z-10"></p>
                    </div>
                    <div className=" text-black p-4 ">
                      <h3 className="text-lg font-semibold">
                        Exceptional Service
                      </h3>
                      <p className="text-sm text-gray-600 tracking-wide leading-relaxed">
                        Exceptional service: find the perfect ladder, positive
                        experience guaranteed.
                      </p>
                    </div>
                  </div>
                </div>

                <div data-aos="fade-up">
                  <div className="space-y-2">
                    <div className="relative mr-4">
                      <LiaCommentDollarSolid className="text-4xl text-black" />
                      <p className="absolute bottom-0 translate-x-2 bg-[#3b5d5033] rounded-full h-[33px] w-[33px] -z-10"></p>
                    </div>
                    <div className=" text-black p-4 ">
                      <h3 className="text-lg font-semibold">
                        Competitive Pricing
                      </h3>
                      <p className="text-sm text-gray-600 tracking-wide leading-relaxed">
                        Competitive pricing, quality assured. Value-driven
                        solutions for your budget.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2 mt-10 lg:mt-0 flex justify-center items-center  ">
              <div className="relative flex justify-center items-center">
                <div className="absolute -left-16 -top-16 w-64 h-56 bg-no-repeat bg-contain -z-10">
                  <img src={svg} alt="" />
                </div>
                <img
                  src={why}
                  alt="products"
                  className="rounded-lg h-96"
                  data-aos="fade-left"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChoose;
